<div class="chips-input__wrapper">
  <!-- chips list -->
  <span class="chip" *ngFor="let chip of chips; let i = index">
    <p>{{ chip }}</p>
    <i class="material-icons" (click)="removeChip(i)"> close </i>
  </span>
  <!-- chip input -->
  <input
    type="text"
    class="chip-input"
    [(ngModel)]="newChipValue"
    [placeholder]="placeholder"
    (keydown.enter)="addChip()"
  />
</div>
